import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import type { TApiSupervisorSegment } from '~/modules/covenants/types.ts';
import {
  buildSegmentsManagerFormValues,
  type TCovenantsSegmentsManagerFormValues,
} from '~/modules/covenants/CovenantsSegmentsManager/utils.ts';

const useCovenantsSegmentsManagerForm = (segments: TApiSupervisorSegment[]) => {
  const formMethods = useForm<TCovenantsSegmentsManagerFormValues>({
    defaultValues: buildSegmentsManagerFormValues(segments),
    mode: 'onTouched',
  });

  useEffect(() => {
    const currentDraftEmails = formMethods.getValues('draftEmails') ?? {};
    const currentSupervisorAdministrationDraftEmails =
      formMethods.getValues('supervisorAdministrationDraftEmails') ?? {};
    formMethods.reset(
      buildSegmentsManagerFormValues(
        segments,
        currentDraftEmails,
        currentSupervisorAdministrationDraftEmails
      )
    );
  }, [segments, formMethods]);

  return formMethods;
};

export default useCovenantsSegmentsManagerForm;
